// searchUtils.js
export const buildSearchQuery = (value) => {
	if (!value) return null;

	const regex = { $regex: value, $options: "i" };

	return {
		$or: [
			{ ma_kh: regex },
			{ ten_kh2: regex },
			{ dien_thoai: regex },
			{
				$expr: {
					$regexMatch: {
						input: {
							$concat: [
								{ $ifNull: ["$ho_ten_dem", ""] },
								" ",
								{ $ifNull: ["$ten_kh", ""] },
							],
						},
						regex: value,
						options: "i",
					},
				},
			},
		],
	};
};

export const handleSearch = (value, params, setParams, handleGetData) => {
	if (value) {
		const searchQuery = buildSearchQuery(value);

		const newQ = {
			...params.q,
			...searchQuery,
		};

		setParams({
			...params,
			page: 1,
			q: newQ,
		});

		handleGetData(newQ);
	} else {
		const newQ = { ...params.q };
		delete newQ.$or;

		setParams({
			...params,
			page: 1,
			q: newQ,
		});

		handleGetData(newQ);
	}
};
